import React from "react";
import { Tab } from "@headlessui/react";
import { TabStyle } from "../../TabStyle";
import { SignalsTab } from "./SignalsTab";
import { ResponsesTab } from "./ResponsesTab";
import { StrategiesTab } from "./StrategiesTab";
export var SitePowerOrchestrator = function () { return (React.createElement("div", { className: "flex flex-col gap-y-[24px]" },
    React.createElement(Tab.Group, null,
        React.createElement(Tab.List, { className: "flex flex-row flex-wrap gap-x-[16px] gap-y-[16px] mb-[16px]" },
            React.createElement(Tab, { className: function (_a) {
                    var selected = _a.selected;
                    return TabStyle(selected);
                } }, "Strategies"),
            React.createElement(Tab, { className: function (_a) {
                    var selected = _a.selected;
                    return TabStyle(selected);
                } }, "Signals"),
            React.createElement(Tab, { className: function (_a) {
                    var selected = _a.selected;
                    return TabStyle(selected);
                } }, "Responses")),
        React.createElement(Tab.Panels, null,
            React.createElement(Tab.Panel, null,
                React.createElement(StrategiesTab, null)),
            React.createElement(Tab.Panel, null,
                React.createElement(SignalsTab, null)),
            React.createElement(Tab.Panel, null,
                React.createElement(ResponsesTab, null)))))); };
